
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taglist",
      function () {
        return require("private-next-pages/taglist/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taglist"])
      });
    }
  